<template>
	<div>
		<CModal title="Ajouter une adresse" size="lg" :show.sync="showModal">
			<form
				:key="key"
				class="mt-3"
				ref="addressForm"
				action="/api/addresses"
				method="post"
				axiosMethod="post">
				<CRow>
					<CCol sm="6">
						<CInput type="text" label="Nom" name="lastName" />
					</CCol>
					<CCol sm="6">
						<CInput type="text" label="Prénom" name="firstName" />
					</CCol>
				</CRow>
				<CRow>
					<CCol sm="12">
						<CInput type="text" label="Dénomination sociale" name="companyName" />
					</CCol>
				</CRow>
				<CRow>
					<CCol sm="12">
						<CInput type="text" label="Adresse" name="address" />
					</CCol>
				</CRow>
				<CRow>
					<CCol sm="12">
						<CInput type="text" label="Complément d'adresse" name="address2" />
					</CCol>
				</CRow>
				<CRow>
					<CCol sm="4">
						<CInput type="text" label="Ville" name="city" />
					</CCol>
					<CCol sm="4">
						<CInput type="text" label="Code postal" name="postalCode" />
					</CCol>
					<CCol sm="4">
						<GSelect
							name="country"
							label="Pays"
							:options="countriesOptions"
							:value="defaultCountry"
							placeholder="Sélectionner un pays" />
					</CCol>
				</CRow>
				<CRow>
					<CCol sm="12">
						<GInputPhoneNumber
							class="phone-input-container"
							inputName="phone"
							label="Téléphone" />
					</CCol>
				</CRow>
				<CInput type="hidden" name="type" :value="type" />
				<CInput type="hidden" name="owner" :value="this.user['@id']" />
			</form>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Fermer</CButton>
				<CButton color="success" v-on:click="onSubmit($refs.addressForm)">Ajouter</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	import GInputPhoneNumber from '../ghostlexly-components/GInputs/GInputPhoneNumber';
	import GSelect from '../ghostlexly-components/GInputs/GSelect';

	export default {
		components: { GInputPhoneNumber, GSelect },
		props: {
			countriesOptions: Array,
			user: Object,
		},
		watch: {
			countriesOptions: {
				immediate: true,
				handler: function (countries) {
					if (countries.length === 0) {
						return;
					}

					const france = countries.find(el => el.label.toLowerCase() === 'france');

					// default country to france
					if (this.defaultCountry === null && france) {
						this.defaultCountry = france.value;
					}
				},
			},
		},
		data() {
			return {
				showModal: false,
				prefix: '',
				type: 'receiver',
				key: 1,
				defaultCountry: null,
				addressIri: null,
			};
		},
		methods: {
			async onSubmit(form) {
				await this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.addressIri = res.data['@id'];
						if (this.type === 'sender') {
							return;
						}
						this.$toast.success('Adresse ajoutée avec succès !');
						this.showModal = false;
						this.key += 1;
						this.$emit('refresh:user');
					}
				});

				if (this.type === 'sender' && this.addressIri !== null) {
					this.$axios
						.patch(
							this.user['@id'],
							{
								address: this.addressIri,
							},
							{
								headers: {
									'Content-Type': 'application/merge-patch+json',
								},
							}
						)
						.then(res => {
							this.$toast.success('Adresse ajoutée avec succès !');
							this.showModal = false;
							this.key += 1;
							this.$emit('refresh:user');
						})
						.catch(err => {
							this.$toast.error(
								"Une erreur est survenue lors de l'ajout de l'adresse, veuillez réessayer ou contacter un administrateur"
							);
						});
				}
			},
		},
	};
</script>
